import $ from 'jquery';
import 'foundation-datepicker/js/foundation-datepicker';

$(() => {
  $('[data-datepicker]').fdatepicker({
    format: 'dd.mm.yyyy',
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/datepicker.js